module.exports = __webpack_public_path__ + "static/media/login-banner-image.a4ca47b0.jpg";